module.exports = __webpack_public_path__ + "img/fa91971ed1d3300b7f578d8427ef013d.png";